export class Agente {
    idagente = '';
    idintegracion?: string;
    nombre = '';
    pass = '';
    penalidad = 0;
    canPause = false;
    canHangup = false;
    canXFER = true;
    modoAgente: EModoAgente;
    logged_on: string;
    estado_fecha: Date;
    estado_idreason: string;
    last_call: string;
    last_call_date: Date;
    // 
    stats?: IStats[];
    
    constructor() {}
}

export interface IStats {
    cola: string;
    completeUsuario: number;
    completeAgente: number;
    completeTiempo: number;
}

export interface IAgentStatusReason {
    idreason: string;
    tipo: string;
    motivo: string;
    autor: string,
    fecha?: any
}

export enum EModoAgente {
    NONE, RINGBACK, AUTOMATIC, OUTBOUND
}

export enum EModalidadAgente {
    RINGBACK, AUTOMATIC, OUTBOUND
}
